import NeighborhoodsModal from './neighborhoods-modal';
export default NeighborhoodsModal;